document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('[data-component="related-pages-toggle"]');
    const backBtn = document.querySelector('[data-component="related-pages-back"]');
    const content = document.querySelector('.c-related-pages__content');

    if (!toggle || !content || !backBtn) {
        return;
    }

    const closeContent = () => {
        toggle.setAttribute('aria-expanded', 'false');
        content.classList.remove('is-open');
    };

    toggle.addEventListener('click', function() {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !isExpanded);
        content.classList.toggle('is-open');
    });

    backBtn.addEventListener('click', closeContent);

});